import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { Users, FileText, CreditCard, TrendingUp, GraduationCap, AlertCircle } from "lucide-react";
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell, Tooltip } from "recharts";

const CARD = [
  ["total_applications", "Applications", FileText],
  ["leads", "Leads captured", Users],
  ["paid_applications", "Fees paid", CreditCard],
  ["admitted", "Admitted", GraduationCap],
  ["unpaid_admitted", "Unpaid admitted", AlertCircle],
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <AdminLayout><div className="p-10 text-paper/40">Loading…</div></AdminLayout>;
  const sourceData = Object.entries(stats.by_source).map(([k, v]) => ({ name: k, value: v }));
  const colors = ["#7A2FD4", "#9B5DE5", "#5A1FA3", "#B98BE8", "#6B27BE"];
  return (
    <AdminLayout>
      <div className="p-8 md:p-10">
        <div className="eyebrow text-heraldic mb-1">Command centre</div>
        <h1 className="font-serif text-4xl text-paper">Institutional overview</h1>

        <div className="mt-8 grid grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {CARD.map(([k, label, Icon]) => (
            <div key={k} className="bg-[#0B0D12] p-5" data-testid={`stat-${k}`}>
              <Icon className="h-5 w-5 text-heraldic" />
              <div className="mt-3 font-serif text-4xl text-paper">{stats[k]}</div>
              <div className="text-xs text-paper/50 mt-1">{label}</div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 border border-white/10 rounded-sm p-6">
            <div className="flex items-center justify-between mb-4"><span className="text-sm text-paper/70">Applications by source</span><TrendingUp className="h-4 w-4 text-heraldic" /></div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={sourceData}>
                <XAxis dataKey="name" stroke="#ffffff40" fontSize={11} />
                <Tooltip contentStyle={{ background: "#14161c", border: "1px solid #ffffff20", borderRadius: 4, color: "#fff" }} cursor={{ fill: "#ffffff08" }} />
                <Bar dataKey="value" radius={[3, 3, 0, 0]}>{sourceData.map((e, i) => <Cell key={i} fill={colors[i % colors.length]} />)}</Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="border border-white/10 rounded-sm p-6">
            <div className="text-sm text-paper/70 mb-4">Revenue pipeline</div>
            <div className="font-serif text-5xl text-heraldic">€{stats.revenue_pipeline.toLocaleString()}</div>
            <div className="text-xs text-paper/40 mt-1">Net tuition across active applications</div>
            <div className="mt-6 space-y-2">
              {Object.entries(stats.by_market).map(([m, v]) => (
                <div key={m} className="flex justify-between text-sm"><span className="text-paper/50 capitalize">{m} market</span><span className="font-mono text-paper">{v}</span></div>
              ))}
              <div className="flex justify-between text-sm border-t border-white/10 pt-2"><span className="text-paper/50">Question bank</span><span className="font-mono text-paper">{stats.questions}</span></div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
